module.exports = __webpack_public_path__ + "img/ep-renard.f024a331.jpg";